import Highcharts from './_highcharts-base';
import {Options} from 'highcharts';

export default function () {
    $(() => {
        for (const chart of $('.time-chart')) {
            const options: Options = {
                chart: {
                    type: 'bar',
                    width: 660,
                    height: 200,
                    marginLeft: 250,
                },
                yAxis: {
                    min: -3,
                    max: 3,
                    tickInterval: 1,
                    title: {
                        text: 'Score Z',
                        style: {
                            fontSize: '8pt',
                            color: 'black'
                        }
                    },
                    labels: {
                        useHTML: true,
                        style: {
                            fontSize: '9pt',
                            color: 'black'
                        },
                    },
                },
                xAxis: {
                    labels: {
                        useHTML: true,
                        style: {
                            fontSize: '10pt',
                            color: 'black'
                        }
                    },
                    lineColor: 'black',
                    tickWidth: 0
                },
            };
            new Highcharts.Chart(
                chart,
                $.extend(true, {}, options, $(chart).data('chart'))
            );
        }
    });
}